import React from 'react';
import { AppContextProvider, useAppContext } from './context/AppContext';
import MapView from './components/map/MapView';
import PinnedClientsList from './components/clients/PinnedClientsList';
import TopBar from './components/common/TopBar';
import './styles/components/common/ConferenceMap.css';

/**
 * Main Conference Map Application Component
 * This is now a simple layout component that uses the Context architecture
 */
const ConferenceMap = () => {
  return (
    <AppContextProvider>
      <ConferenceMapContent />
    </AppContextProvider>
  );
};

/**
 * Inner component that has access to context
 */
const ConferenceMapContent = () => {
  const { filters: { selectedYear } } = useAppContext();
  const isHistoryMode = selectedYear !== 'All';

  return (
    <div className={`app-container ${isHistoryMode ? 'history-mode' : ''}`}>
      <div className={`history-mode-overlay ${isHistoryMode ? 'visible' : 'hidden'}`} />
      
      <TopBar />
      
      <div className="conference-map-container">
        <MapView />
        <PinnedClientsList />
      </div>
    </div>
  );
};

export default ConferenceMap;
